import { ArrowRightIcon } from "@heroicons/react/solid";
import LoadingButton from "@mui/lab/LoadingButton";
import Modal from "@mui/material/Modal";
import { DatePicker } from "@mui/x-date-pickers";
import axios from "axios";
import dayjs from "dayjs";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Swal from "sweetalert2";
import check from "../../asset/check.png";
import pdfFile from "../../asset/pdf-file.png";
import upload from "../../asset/upload.png";
import "../../styles/logo.css";
import { PihtasModal } from "../helpers/modal";
import { Header } from "../header";
import { useLoginStore, useProfileStore } from "../helpers/state";
import {
  validateFile,
  shortenFilename,
  validationConfigs,
} from "../helpers/fileValidation";
import html2canvas from "html2canvas";
// Removed shirt size chart image per new specs

toast.configure();

export function PermohonanPihtas() {
  const { login } = useLoginStore();
  const { profile } = useProfileStore();
  var CryptoJS = require("crypto-js");
  const [modalOpen, setModalOpen] = useState(true);

  function closeModal() {
    setModalOpen(false);
  }
  const [sendLoader, setSendLoader] = useState(false);

  const [spih, setspih] = useState("Muat naik");
  const [izin, setIzin] = useState("Muat naik");
  const [suratMajikan, setSuratMajikan] = useState("Muat naik");

  const navigate = useNavigate();

  const [Hspih, setHspih] = useState("hidden");
  const [Hizin, setHizin] = useState("hidden");
  const [HSuratMajikan, setHSuratMajikan] = useState("hidden");

  const [fileSpih, setFileSpih] = useState(null);
  const [fileIzin, setFileIzin] = useState(null);
  const [fileSuratMajikan, setFileSuratMajikan] = useState(null);

  const [Iwali, setIWali] = useState(upload);
  const [ISpih, setISpih] = useState(upload);
  const [ISuratMajikan, setISuratMajikan] = useState(upload);

  const [spihYear, setSpihYear] = useState(null);
  // Saiz Pakaian fields
  const [sizeVest, setSizeVest] = useState("");
  const [sizeJaket, setSizeJaket] = useState("");
  const [sizeTshirt, setSizeTshirt] = useState("");
  const [sizeBajuKorporat, setSizeBajuKorporat] = useState("");
  const [kopiahInch, setKopiahInch] = useState("");
  const kopiahOptions = (() => {
    const opts = [];
    const quarters = ["", "1/4", "1/2", "3/4"];
    for (let whole = 20; whole <= 24; whole++) {
      for (let q = 0; q < quarters.length; q++) {
        if (whole === 24 && quarters[q] !== "") continue;
        const label = quarters[q] ? `${whole} ${quarters[q]}` : `${whole}`;
        opts.push(label);
      }
    }
    return opts;
  })();

  const [rekodPihtas, setRekodPihtas] = useState([]);
  const [ackAgreed, setAckAgreed] = useState(false);

  let spihID, izinID;
  let formData;
  const bytes = CryptoJS.AES.decrypt(
    login.jwtToken,
    `${process.env.SECRET_KEY}`
  );
  var userToken = bytes.toString(CryptoJS.enc.Utf8);
  const pektaID = login.pektaID;

  // Using utility functions from fileValidation.js

  function handleUpload() {
    // Client-side validations for mandatory fields
    const missingFields = [];
    if (!spihYear) missingFields.push("Tahun SPIH/EPIH");
    if (!fileSpih) missingFields.push("Fail Sijil SPIH/EPIH");
    if (!sizeVest) missingFields.push("Saiz Vest");
    if (!sizeJaket) missingFields.push("Saiz Jaket");
    if (!sizeTshirt) missingFields.push("Saiz T-Shirt");
    if (!ackAgreed) missingFields.push("Pengakuan: Sila tandakan 'Setuju'");

    // Validate Sejarah Rekod PIHTAS rows: any added row must be complete
    if (rekodPihtas.length > 0) {
      rekodPihtas.forEach((row, idx) => {
        const rowIndex = idx + 1;
        const hasAny = Boolean(
          (row?.bertugas_dengan && String(row.bertugas_dengan).trim() !== "") ||
            (row?.sektor && String(row.sektor).trim() !== "") ||
            (row?.tahun && String(row.tahun).trim() !== "") ||
            row?.file
        );

        const missing = [];
        if (!row?.bertugas_dengan) missing.push("Pengalaman Bertugas");
        if (!row?.sektor) missing.push("Sektor");
        if (!row?.tahun) missing.push("Tahun");
        if (!row?.file) missing.push("Fail Rekod");

        if (!hasAny) {
          missingFields.push(
            `Pengalaman Bertugas Baris ${rowIndex} kosong. Jika tidak digunakan, sila Padam baris untuk meneruskan permohonan.`
          );
        } else if (missing.length > 0) {
          missingFields.push(
            `Pengalaman Bertugas Baris ${rowIndex}: ${missing.join(", ")}`
          );
        }
      });
    }

    if (missingFields.length > 0) {
      Swal.fire({
        icon: "warning",
        title: "Maklumat wajib belum lengkap",
        html: `<div class="text-left">Sila isi/muat naik medan berikut:<ul class="list-disc ml-5 mt-2">${missingFields
          .map((f) => `<li>${f}</li>`)
          .join("")}</ul></div>`,
      });
      return;
    }
    setSendLoader(true);
    let appData;
    formData = new FormData();
    formData.append("files", fileSpih);
    if (fileIzin) {
      formData.append("files", fileIzin);
    }
    if (fileSuratMajikan) {
      formData.append("files", fileSuratMajikan);
    }
    // Upload all rekodPihtas files
    rekodPihtas.forEach((row) => {
      if (row.file) {
        formData.append("files", row.file);
      }
    });
    axios
      .post(`${process.env.REACT_APP_API_URL}/api/upload/`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        onUploadProgress: function (progressEvent) {
          var percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          console.log(percentCompleted);
        },
      })
      .then((response) => {
        // response.data is an array of uploaded file objects in order
        let uploadIdx = 0;
        const spihID = response.data[uploadIdx++].id;
        localStorage.setItem("spihID", spihID);
        let izinID = null;
        if (fileIzin) {
          izinID = response.data[uploadIdx++].id;
          localStorage.setItem("izinID", izinID);
        }
        let suratMajikanID = null;
        if (fileSuratMajikan) {
          suratMajikanID = response.data[uploadIdx++].id;
        }
        // Map rekodPihtas to include file IDs
        const rekodPihtasData = rekodPihtas.map((row) => {
          let file = null;
          if (row.file) {
            file = response.data[uploadIdx++].id;
          }
          return {
            bertugas_dengan: row.bertugas_dengan,
            sector: row.sektor || null,
            year: row.tahun || null,
            file,
          };
        });

        // Convert kopiah size to snake_case format with size_ prefix for payload (e.g.: "20 1/4" -> "size_20_1_4")
        const formatKopiahSize = (size) => {
          if (!size) return null;
          return "size_" + size.replace(/\s+/g, "_").replace(/\//g, "_");
        };

        appData = JSON.stringify({
          data: {
            status: "pending",
            file_sijil_pembimbing_ibadat: spihID,
            sijil_pembimbing_ibadat_year: spihYear,
            file_izin_suami_wali: izinID,
            file_surat_majikan: suratMajikanID,
            saiz_vest: sizeVest,
            saiz_jaket: sizeJaket,
            saiz_baju_korporat: sizeBajuKorporat || null,
            saiz_tshirt: sizeTshirt,
            saiz_kopiah: formatKopiahSize(kopiahInch),
            sejarah_rekod_pihtas: rekodPihtasData,
            pekta: pektaID,
          },
        });
        let applicationConfig = {
          method: "post",
          url: `${process.env.REACT_APP_API_URL}/api/pihtas-applications`,
          headers: {
            Authorization: `Bearer ${userToken}`,
            "Content-Type": "application/json",
          },
          data: appData,
        };
        axios(applicationConfig)
          .then((response) => {
            setSendLoader(false);
            toast.success(
              "Permohonan berjaya, sila tunggu pengesahan daripada Bahagian Bimbingan Haji",
              { position: toast.POSITION.TOP_CENTER }
            );
            console.log("application submitted successfully");
            const originalDateString = response.data.data.attributes.createdAt;
            const date = new Date(originalDateString);
            const day = date.getDate().toString().padStart(2, "0");
            const month = (date.getMonth() + 1).toString().padStart(2, "0");
            const year = date.getFullYear();
            const formattedDate = `${day}/${month}/${year}`;
          //   Swal.fire({
          //     icon: "success",
          //     title: "Permohonan PIHTAS Berjaya",
          //     html: `ID Permohonan: ${response.data.data.id}<br>
          //   Name pemohon: ${profile.full_name}<br>
          //   Emel pemohon: ${login.email}<br>
          //   Tarikh permohonan: ${formattedDate}`,
          //     footer:
          //       "Sila tangkap layar resit permohonan ini untuk bukti permohonan.",
          //     customClass: {
          //       footer: "SwalFooter",
          //     },
          //   });
          //   navigate("/myprofile");
          // })
          Swal.fire({
            icon: "success",
            title: "Permohonan PIHTAS Berjaya",
            html: `ID Permohonan: ${response.data.data.id}<br>
                 Name pemohon: ${profile.full_name}<br>
                 Emel pemohon: ${login.email}<br>
                 Tarikh permohonan: ${formattedDate}`,
            footer: `
              Resit permohonan ini akan dimuat turun secara automatik untuk bukti permohonan KATAM.<br>
              Sila tangkap layar dan simpan untuk bukti Permohonan KATAM.
            `,
            confirmButtonText: "Ok",
            customClass: {
              footer: "SwalFooter",
            },
            didOpen: () => {
              const popup = Swal.getPopup();
              if (!popup) return;
              setTimeout(() => {
                // Clone the live popup into an off-screen, static container
                const clone = popup.cloneNode(true);
                // Reset positioning/layout so html2canvas gets a stable box
                clone.style.position = "static";
                clone.style.transform = "none";
                clone.style.margin = "0 auto";
                clone.style.boxShadow = "none";
                const liveWidth = popup.offsetWidth || 520;
                clone.style.maxWidth = `${liveWidth}px`;
                clone.style.width = `${liveWidth}px`;
                clone.style.padding = "20px 20px 16px 20px";
  
                const wrapper = document.createElement("div");
                wrapper.style.position = "fixed";
                wrapper.style.left = "-9999px";
                wrapper.style.top = "0";
                wrapper.style.width = `${liveWidth}px`;
                wrapper.appendChild(clone);
                document.body.appendChild(wrapper);
  
                // Freeze success icon animation and normalize text/button layout in the clone
                const style = document.createElement("style");
                style.innerHTML = `
                  .swal2-icon.swal2-success .swal2-success-ring,
                  .swal2-icon.swal2-success [class^="swal2-success-line"],
                  .swal2-icon.swal2-success .swal2-success-fix { animation: none !important; transition: none !important; }
                  .swal2-popup { box-sizing: border-box !important; background: #fff !important; }
                  .swal2-title { margin: 8px 0 14px 0 !important; line-height: 1.35 !important; font-weight: 600 !important; text-align: center !important; }
                  .swal2-html-container { margin: 0 0 30px 0 !important; line-height: 1.5 !important; word-break: break-word !important; white-space: normal !important; text-align: center !important; }
                `;
                clone.prepend(style);
                
                // Hide button and footer in the clone before capturing
                const actionsContainer = clone.querySelector('.swal2-actions');
                if (actionsContainer) {
                  actionsContainer.style.display = 'none';
                }
                // Also hide the button directly by its classes
                const confirmBtn = clone.querySelector('.swal2-confirm') || clone.querySelector('.katam-receipt-confirm');
                if (confirmBtn) {
                  confirmBtn.style.display = 'none';
                }
                const footer = clone.querySelector('.swal2-footer');
                if (footer) {
                  footer.style.display = 'none';
                }
  
                html2canvas(clone, {
                  scale: 2,
                  useCORS: true,
                  scrollX: 0,
                  scrollY: 0,
                  onclone: (clonedDoc) => {
                    // Hide the button and footer in the screenshot (keep them in live modal)
                    const actionsContainer = clonedDoc.querySelector('.swal2-actions');
                    if (actionsContainer) {
                      actionsContainer.style.display = 'none';
                    }
                    // Also hide the button directly by its classes
                    const confirmBtn = clonedDoc.querySelector('.swal2-confirm') || clonedDoc.querySelector('.katam-receipt-confirm');
                    if (confirmBtn) {
                      confirmBtn.style.display = 'none';
                    }
                    const footer = clonedDoc.querySelector('.swal2-footer');
                    if (footer) {
                      footer.style.display = 'none';
                    }
                  },
                })
                  .then((canvas) => {
                    canvas.toBlob((blob) => {
                      if (!blob) return;
                      const url = URL.createObjectURL(blob);
                      const a = document.createElement("a");
                      a.href = url;
                      a.download = `Resit_Permohonan_PIHTAS-${response.data.data.id}.png`;
                      document.body.appendChild(a);
                      a.click();
                      a.remove();
                      URL.revokeObjectURL(url);
                    });
                  })
                  .catch(() => {
                    // Ignore capture errors; user can still screenshot manually
                  })
                  .finally(() => {
                    document.body.removeChild(wrapper);
                  });
              }, 1000);
            },
          }).then(() => {
            navigate("/myprofile");
            })
          })
          .catch((error) => {
            setSendLoader(false);
            const apiMsg =
              error?.response?.data?.error?.message ||
              error?.response?.data?.message ||
              "Permohonan tidak berjaya, sila cuba lagi.";
            Swal.fire({
              icon: "error",
              title: "Ralat Semasa Menghantar Permohonan",
              text: `${apiMsg}`,
            });
            console.log("An error occurred address:", error.response);
          });
      })
      .catch((error) => {
        setSendLoader(false);
        const uploadMsg =
          error?.response?.data?.error?.message ||
          error?.message ||
          "Muat naik dokumen gagal, sila cuba lagi.";
        Swal.fire({
          icon: "error",
          title: "Ralat Muat Naik",
          text: `${uploadMsg}`,
        });
        console.log("error: ", error);
      });
  }

  return (
    <>
      <Header />
      <div className="bg-gray-50 h-screen pb-5">
        <main className="flex flex-col">
          <div className="ml-28 mt-8 mb-4">
            <button className="text-gray-500 font-medium">
              <Link to={"/myprofile"}>🡨 Kembali ke Profil</Link>
            </button>
          </div>
          <div className="bg-white rounded-md lg:mx-24 sm:mx-36 m-2">
            <div className=" mx-2 pt-10 mb-10 p-2 ">
              <p className="text-4xl mb-5">Dokumen Permohonan PIHTAS</p>
              <label>
                Dokumen dengan <b className="text-red-500">*</b> wajib di isi
                dengan lengkap
              </label>
              <div className="border-2 flex flex-col sm:flex-row p-3">
                <div className="bg-white border-2 rounded-md border-grey-400 w-5 h-5 flex flex-shrink-0 justify-center items-center mb-2 sm:mr-2 sm:mt-0 sm:mb-03">
                  <svg
                    className={`fill-current ${Hspih}  w-3 h-3 text-green-600 pointer-events-none`}
                    version="1.1"
                    viewBox="0 0 17 12"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g fill="none">
                      <g transform="translate(-9 -11)" fill="#52912C">
                        <path d="m25.576 11.414c0.56558 0.55188 0.56558 1.4439 0 1.9961l-9.404 9.176c-0.28213 0.27529-0.65247 0.41385-1.0228 0.41385-0.37034 0-0.74068-0.13855-1.0228-0.41385l-4.7019-4.588c-0.56584-0.55188-0.56584-1.4442 0-1.9961 0.56558-0.55214 1.4798-0.55214 2.0456 0l3.679 3.5899 8.3812-8.1779c0.56558-0.55214 1.4798-0.55214 2.0456 0z" />
                      </g>
                    </g>
                  </svg>
                </div>

                <div className="flex flex-col sm:flex-row justify-between w-full">
                  <label className="mr-auto mb-2 text-sm sm:mb-0">
                    Sijil Pembimbing Ibadat Haji (SPIH) / Program Eksekutif
                    Pembimbing Ibadat Haji (EPIH){" "}
                    <b className="text-red-500">*</b>
                  </label>
                  <DatePicker
                    sx={{
                      input: { "&::placeholder": { opacity: 1 } },
                      "&:hover .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#E5E7EB",
                      },
                      ".MuiOutlinedInput-notchedOutline": {
                        borderRadius: "8px",
                      },
                      label: { color: "black" },
                    }}
                    slotProps={{
                      textField: { placeholder: "Tahun", size: "small" },
                    }}
                    className="MyDatePicker border-2 w-40"
                    views={["year"]}
                    onChange={(e) => {
                      setSpihYear(dayjs(e.$d).format("YYYY"));
                    }}
                  />
                  <div className="mt-3 sm:mt-0 sm:ml-5 h-10 w-32 rounded-md cursor-pointer">
                    <label className="w-32 h-10 border-2 pl-3 rounded-lg cursor-pointer flex items-center">
                      <img
                        alt="upload"
                        className="h-4 w-4 float-left mt-1 mr-2 bg-fixed"
                        src={ISpih}
                      />
                      {spih}
                      <input
                        id="spih"
                        className=" border-2  hidden"
                        accept="image/*,application/pdf"
                        type={"file"}
                        onChange={(e) => {
                          const file = e.target.files[0];
                          if (file) {
                            const validation = validateFile(
                              file,
                              validationConfigs.default
                            );
                            if (!validation.valid) {
                              Swal.fire({
                                icon: "error",
                                title: "Jenis Fail Tidak Sah",
                                text: validation.message,
                              });
                              e.target.value = ""; // Clear the input
                              return;
                            }

                            setspih(
                              shortenFilename(
                                e.target.value
                                  .toString()
                                  .split(/(\\|\/)/g)
                                  .pop()
                              )
                            );
                            setHspih("");
                            setISpih(check);
                            setFileSpih(file);
                          }
                        }}
                      />
                    </label>
                  </div>
                </div>
              </div>

              <div className="border-2 flex flex-col sm:flex-row p-3 border-t-0">
                <div className="bg-white border-2 rounded-md border-grey-400 w-5 h-5 flex flex-shrink-0 justify-center items-center mb-2 sm:mr-2 sm:mt-0 sm:mb-0">
                  <svg
                    className={`fill-current ${Hizin}  w-3 h-3 text-green-600 pointer-events-none`}
                    version="1.1"
                    viewBox="0 0 17 12"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g fill="none">
                      <g transform="translate(-9 -11)" fill="#52912C">
                        <path d="m25.576 11.414c0.56558 0.55188 0.56558 1.4439 0 1.9961l-9.404 9.176c-0.28213 0.27529-0.65247 0.41385-1.0228 0.41385-0.37034 0-0.74068-0.13855-1.0228-0.41385l-4.7019-4.588c-0.56584-0.55188-0.56584-1.4442 0-1.9961 0.56558-0.55214 1.4798-0.55214 2.0456 0l3.679 3.5899 8.3812-8.1779c0.56558-0.55214 1.4798-0.55214 2.0456 0z" />
                      </g>
                    </g>
                  </svg>
                </div>

                <div className="flex flex-col sm:flex-row justify-between w-full">
                  <label className="mr-auto mb-2 text-sm sm:mb-0">
                    Izin suami/wali bertulis (Permohonan PIHTAS bagi wanita){" "}
                  </label>
                  <div
                    className="border-2 w-48 pl-3 pr-2 pt-1 hover:cursor-pointer rounded-md flex flex-row"
                    onClick={() =>
                      window.open(require("../../asset/wali.pdf"), "_none")
                    }
                  >
                    <div className="text-center mr-1">Muat turun borang</div>
                    <img className="w-6 h-6" src={pdfFile} alt="pdf"></img>
                  </div>
                  <div className="mt-3 sm:mt-0 sm:ml-5 h-10 w-32 rounded-md">
                    <label className="w-32 h-10 border-2 pl-3 rounded-lg cursor-pointer flex items-center">
                      <img
                        className="h-4 w-4 float-left mt-1 mr-2 bg-fixed"
                        alt="upload"
                        src={Iwali}
                      />
                      {izin}
                      <input
                        id="izin"
                        className=" border-2  hidden"
                        accept="image/*,application/pdf"
                        type={"file"}
                        onChange={(e) => {
                          const file = e.target.files[0];
                          if (file) {
                            const validation = validateFile(
                              file,
                              validationConfigs.default
                            );
                            if (!validation.valid) {
                              Swal.fire({
                                icon: "error",
                                title: "Jenis Fail Tidak Sah",
                                text: validation.message,
                              });
                              e.target.value = ""; // Clear the input
                              return;
                            }

                            setIzin(
                              shortenFilename(
                                e.target.value
                                  .toString()
                                  .split(/(\\|\/)/g)
                                  .pop()
                              )
                            );
                            setIWali(check);
                            setHizin("");
                            setFileIzin(file);
                          }
                        }}
                      />
                    </label>
                  </div>
                </div>
              </div>

              {/* Surat Kebenaran Majikan (optional) */}
              <div className="border-2 flex flex-col sm:flex-row p-3 border-t-0">
                <div className="bg-white border-2 rounded-md border-grey-400 w-5 h-5 flex flex-shrink-0 justify-center items-center mb-2 sm:mr-2 sm:mt-0 sm:mb-0">
                  <svg
                    className={`fill-current ${HSuratMajikan}  w-3 h-3 text-green-600 pointer-events-none`}
                    version="1.1"
                    viewBox="0 0 17 12"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g fill="none">
                      <g transform="translate(-9 -11)" fill="#52912C">
                        <path d="m25.576 11.414c0.56558 0.55188 0.56558 1.4439 0 1.9961l-9.404 9.176c-0.28213 0.27529-0.65247 0.41385-1.0228 0.41385-0.37034 0-0.74068-0.13855-1.0228-0.41385l-4.7019-4.588c-0.56584-0.55188-0.56584-1.4442 0-1.9961 0.56558-0.55214 1.4798-0.55214 2.0456 0l3.679 3.5899 8.3812-8.1779c0.56558-0.55214 1.4798-0.55214 2.0456 0z" />
                      </g>
                    </g>
                  </svg>
                </div>
                <div className="flex flex-col sm:flex-row justify-between w-full">
                  <label className="mr-auto mb-2 text-sm sm:mb-0">
                    Surat Kebenaran Majikan
                  </label>
                  <div className="mt-3 sm:mt-0 sm:ml-5 h-10 w-32 rounded-md cursor-pointer">
                    <label className="w-32 h-10 border-2 pl-3 rounded-lg cursor-pointer flex items-center">
                      <img
                        alt="upload"
                        className="h-4 w-4 float-left mt-1 mr-2 bg-fixed"
                        src={ISuratMajikan}
                      />
                      {suratMajikan}
                      <input
                        id="suratMajikan"
                        className=" border-2  hidden"
                        accept="image/*,application/pdf"
                        type={"file"}
                        onChange={(e) => {
                          const file = e.target.files[0];
                          if (file) {
                            const validation = validateFile(
                              file,
                              validationConfigs.default
                            );
                            if (!validation.valid) {
                              Swal.fire({
                                icon: "error",
                                title: "Jenis Fail Tidak Sah",
                                text: validation.message,
                              });
                              e.target.value = ""; // Clear the input
                              return;
                            }

                            setSuratMajikan(
                              shortenFilename(
                                e.target.value
                                  .toString()
                                  .split(/(\\|\/)/g)
                                  .pop()
                              )
                            );
                            setHSuratMajikan("");
                            setISuratMajikan(check);
                            setFileSuratMajikan(file);
                          }
                        }}
                      />
                    </label>
                  </div>
                </div>
              </div>

              {/* Saiz Baju Dropdown */}
              <div className="flex flex-col gap-3 border-2 border-t-0 p-3">
                <p className="text-2xl">Saiz Pakaian</p>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                  <div>
                    <label className="block text-sm font-medium mb-2">
                      Vest <b className="text-red-500">*</b>
                    </label>
                    <select
                      className="border-2 rounded-md p-2 w-full"
                      value={sizeVest}
                      onChange={(e) => setSizeVest(e.target.value)}
                    >
                      <option value="">Pilih Saiz</option>
                      <option value="XS">XS</option>
                      <option value="S">S</option>
                      <option value="M">M</option>
                      <option value="L">L</option>
                      <option value="XL">XL</option>
                      <option value="XXL">XXL</option>
                      <option value="XXXL">XXXL</option>
                    </select>
                  </div>
                  <div>
                    <label className="block text-sm font-medium mb-2">
                      Jaket <b className="text-red-500">*</b>
                    </label>
                    <select
                      className="border-2 rounded-md p-2 w-full"
                      value={sizeJaket}
                      onChange={(e) => setSizeJaket(e.target.value)}
                    >
                      <option value="">Pilih Saiz</option>
                      <option value="XS">XS</option>
                      <option value="S">S</option>
                      <option value="M">M</option>
                      <option value="L">L</option>
                      <option value="XL">XL</option>
                      <option value="XXL">XXL</option>
                      <option value="XXXL">XXXL</option>
                    </select>
                  </div>
                  <div>
                    <label className="block text-sm font-medium mb-2">
                      T-Shirt <b className="text-red-500">*</b>
                    </label>
                    <select
                      className="border-2 rounded-md p-2 w-full"
                      value={sizeTshirt}
                      onChange={(e) => setSizeTshirt(e.target.value)}
                    >
                      <option value="">Pilih Saiz</option>
                      <option value="XS">XS</option>
                      <option value="S">S</option>
                      <option value="M">M</option>
                      <option value="L">L</option>
                      <option value="XL">XL</option>
                      <option value="XXL">XXL</option>
                      <option value="XXXL">XXXL</option>
                    </select>
                  </div>
                  <div>
                    <label className="block text-sm font-medium mb-2">
                      Baju korporat Petugas (Lelaki Sahaja)
                    </label>
                    <select
                      className="border-2 rounded-md p-2 w-full"
                      value={sizeBajuKorporat}
                      onChange={(e) => setSizeBajuKorporat(e.target.value)}
                    >
                      <option value="">Pilih Saiz</option>
                      <option value="XS">XS</option>
                      <option value="S">S</option>
                      <option value="M">M</option>
                      <option value="L">L</option>
                      <option value="XL">XL</option>
                      <option value="XXL">XXL</option>
                      <option value="XXXL">XXXL</option>
                    </select>
                  </div>
                  <div>
                    <label className="block text-sm font-medium mb-2">
                      Kopiah (Ukuran Lilit Kepala dalam Inci - Lelaki Sahaja)
                    </label>
                    <select
                      className="border-2 rounded-md p-2 w-full"
                      value={kopiahInch}
                      onChange={(e) => setKopiahInch(e.target.value)}
                    >
                      <option value="">Pilih Saiz Kopiah</option>
                      {kopiahOptions.map((opt) => (
                        <option key={opt} value={opt}>
                          {opt}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>

              {/* Sejarah Rekod PIHTAS Section */}
              <div className="mb-8 p-3 border-2 border-t-0">
                <div className="flex flex-row items-center justify-between mb-4">
                  <h2 className="text-xl font-semibold">
                    Pengalaman bertugas di tanah suci (Pengalaman 3 Tahun Hijrah
                    Terakhir)
                  </h2>
                  <button
                    type="button"
                    className="bg-lime-700 text-white px-4 py-2 rounded-md text-sm font-medium"
                    onClick={() =>
                      setRekodPihtas([
                        ...rekodPihtas,
                        {
                          bertugas_dengan: "",
                          sektor: "",
                          tahun: "",
                          file: null,
                          filename: "Muat naik",
                        },
                      ])
                    }
                  >
                    Tambah
                  </button>
                </div>
                {rekodPihtas.length === 0 ? (
                  <div className="text-gray-500 text-center py-4">
                    Tiada Rekod
                  </div>
                ) : (
                  <>
                    <div className="mb-2">
                      <div className="mt-2 text-sm text-gray-700 bg-yellow-50 border border-yellow-200 rounded px-3 py-2">
                        Nota: Baris yang ditambah wajib diisi sepenuhnya
                        (Pengalaman Bertugas, Sektor, Tahun dan Fail Rekod).
                        Jika tidak diperlukan, sila tekan <b>Padam</b> untuk
                        meneruskan permohonan.
                      </div>
                    </div>
                    {/* Column headers (shown when at least one row exists) */}
                    <div className="hidden md:flex md:flex-row md:items-center gap-3 md:gap-2 px-1 pb-1 text-md">
                      <div className="md:flex-1 md:min-w-0">
                        Pengalaman Bertugas <b className="text-red-500">*</b>
                      </div>
                      <div className="md:flex-1 md:min-w-0">
                        Sektor <b className="text-red-500">*</b>
                      </div>
                      <div className="md:flex-1 md:min-w-0 md:max-w-[180px]"></div>
                      <div className="md:flex-1 md:min-w-0"></div>
                      <div className="md:w-24"></div>
                    </div>
                    <div className="space-y-4">
                      {rekodPihtas.map((row, idx) => (
                        <div
                          key={idx}
                          className="flex flex-col md:flex-row md:items-center gap-3 md:gap-2"
                        >
                          <div className="w-full md:flex-1 md:min-w-0">
                            <label className="block text-sm font-medium mb-1 md:sr-only">
                              Pengalaman Bertugas{" "}
                              <b className="text-red-500">*</b>
                            </label>
                            <select
                              className="border-2 rounded-md p-2 w-full h-9 text-sm"
                              aria-label="Pengalaman Bertugas"
                              value={row.bertugas_dengan}
                              onChange={(e) => {
                                const newRows = [...rekodPihtas];
                                newRows[idx].bertugas_dengan = e.target.value;
                                setRekodPihtas(newRows);
                              }}
                            >
                              <option value="">
                                Pilih Pengalaman Bertugas
                              </option>
                              <option value="Tabung Haji">Tabung Haji</option>
                              <option value="Pengelola Jemaah Haji">
                                Pengelola Jemaah Haji
                              </option>
                            </select>
                          </div>
                          <div className="w-full md:flex-1 md:min-w-0">
                            <label className="block text-sm font-medium mb-1 md:sr-only">
                              Sektor <b className="text-red-500">*</b>
                            </label>
                            <select
                              className="border-2 rounded-md p-2 w-full h-9 text-sm"
                              aria-label="Sektor"
                              value={row.sektor || ""}
                              onChange={(e) => {
                                const newRows = [...rekodPihtas];
                                newRows[idx].sektor = e.target.value;
                                setRekodPihtas(newRows);
                              }}
                            >
                              <option value="">Pilih Sektor</option>
                              <option value="Makkah">Makkah</option>
                              <option value="Madinah">Madinah</option>
                            </select>
                          </div>
                          <div className="w-full md:flex-1 md:min-w-0 md:max-w-[180px]">
                            <label className="block text-sm font-medium mb-1 md:sr-only">
                              Tahun
                            </label>
                            <DatePicker
                              label={"Tahun"}
                              views={["year"]}
                              value={
                                row.tahun ? dayjs(`${row.tahun}-01-01`) : null
                              }
                              onChange={(e) => {
                                const newRows = [...rekodPihtas];
                                newRows[idx].tahun = e
                                  ? dayjs(e.$d).format("YYYY")
                                  : "";
                                setRekodPihtas(newRows);
                              }}
                              slotProps={{ textField: { size: "small" } }}
                              sx={{
                                input: {
                                  "&::placeholder": { opacity: 1 },
                                  fontSize: 12,
                                },
                                ".MuiOutlinedInput-input": {
                                  padding: "6px 10px",
                                },
                                ".MuiOutlinedInput-notchedOutline": {
                                  borderRadius: "8px",
                                },
                                ".MuiInputLabel-root": { fontSize: 12 },
                              }}
                              className="MyDatePicker w-full"
                            />
                          </div>
                          <div className="w-full md:flex-1 md:min-w-0">
                            <label className="block text-sm font-medium mb-1 md:sr-only">
                              Muat naik
                            </label>
                            <label className="w-full h-9 border-2 pl-3 pr-2 rounded-lg cursor-pointer flex items-center text-sm">
                              <img
                                alt="upload"
                                className="h-4 w-4 mr-2 bg-fixed"
                                src={row.file ? check : upload}
                              />
                              <span className="truncate inline-block align-middle md:min-w-0">
                                {row.filename}
                              </span>
                              <input
                                className="border-2 hidden"
                                accept="image/*,application/pdf"
                                type="file"
                                onChange={(e) => {
                                  const file = e.target.files[0];
                                  if (file) {
                                    const validation = validateFile(
                                      file,
                                      validationConfigs.default
                                    );
                                    if (!validation.valid) {
                                      Swal.fire({
                                        icon: "error",
                                        title: "Jenis Fail Tidak Sah",
                                        text: validation.message,
                                      });
                                      e.target.value = ""; // Clear the input
                                      return;
                                    }

                                    const newRows = [...rekodPihtas];
                                    newRows[idx].file = file;
                                    newRows[idx].filename = file
                                      ? file.name
                                      : "Muat naik";
                                    setRekodPihtas(newRows);
                                  }
                                }}
                              />
                            </label>
                          </div>
                          <div className="w-full md:w-24 flex md:justify-end">
                            <button
                              type="button"
                              className="w-full md:w-auto text-red-600 border border-red-600 px-3 py-2 rounded-md text-xs font-medium hover:bg-red-50"
                              onClick={() =>
                                setRekodPihtas(
                                  rekodPihtas.filter((_, i) => i !== idx)
                                )
                              }
                            >
                              Padam
                            </button>
                          </div>
                        </div>
                      ))}
                    </div>
                  </>
                )}
              </div>
              <div className="p-3">
                <p className="text-xl font-semibold mb-4">
                  Pengakuan <span className="text-red-500">*</span>
                </p>
                <p className="text-sm text-gray-700">
                  Pemohon telah mendapatkan kebenaran bertugas dari majikan
                  masing-masing dan izin suami/wali (Permohonan PIHTAS Wanita)
                </p>
                <div className="mt-3 flex items-center gap-2">
                  <input
                    id="ackAgree"
                    type="checkbox"
                    className="w-4 h-4"
                    checked={ackAgreed}
                    onChange={(e) => setAckAgreed(e.target.checked)}
                  />
                  <label htmlFor="ackAgree" className="text-sm">
                    Setuju
                  </label>
                </div>
              </div>
            </div>

            <div className="text-center mb-8">
              <LoadingButton
                onClick={handleUpload}
                loading={sendLoader}
                loadingPosition="end"
                variant="contained"
                color="success"
                sx={{ borderRadius: "5px", margin: "7px" }}
                size="medium"
                endIcon={<ArrowRightIcon className="h-5 w-5 " />}
              >
                Hantar
              </LoadingButton>
            </div>
          </div>
        </main>
      </div>
      <Modal
        className=""
        open={sendLoader}
        onClose={() => console.log("close")}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div className="flex justify-center items-center h-screen"></div>
      </Modal>
      <PihtasModal open={modalOpen} closeModal={closeModal} />
    </>
  );
}
